<template>
    <div class="vh-100 vw-100 d-flex flex-column">
      <DefaultHeader :noMargin="true"/>
      <MissionMap />
    </div>
  </template>
  
  <script>
  import DefaultHeader from '@/components/DefaultHeader.vue'
  import MissionMap from './Sections/MissionMap.vue'
  
  export default {
      components: {
          DefaultHeader,
          MissionMap
      },
      computed: {
          currentUser() {
              return this.$store.state.auth.user
          }
      },
      mounted() {
          if (!this.currentUser) {
              this.$router.push('/')
          }
      }
  }
  </script>